// @ts-nocheck
import { Link, useLocation } from "react-router-dom";
import { getHighlights, toTitleCase } from "../../../utils/parcelFormatters";
import { Parcel } from "../../../services/parcelTypes";

export function ParcelDetailHeader({
    parcel,
    isEditing,
    isSaving,
    saveMessage,
    saveError,
    onEdit,
    onCancel,
    onSave,
}: {
    parcel: Parcel;
    isEditing: boolean;
    isSaving: boolean;
    saveMessage: string | null;
    saveError: string | null;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
}) {
    const location = useLocation();
    const { pin, primaryDisplay, landUse, landUseCategory } = getHighlights(parcel);

    return (
        <header className="mb-4 pt-8 bg-[#21506F] px-4">
            <Link
                to={`/parcels${location.search}`}
                className="back-btn"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1"/>
                </svg>
                Back to parcels
            </Link>

            <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                <div className="min-w-0 py-4">
                    <h1 className="text-xl text-white">
                        {toTitleCase(primaryDisplay?.value)}
                    </h1>
                    <div className="flex flex-wrap items-start gap-2">
                        <p className="parcel-id">{pin} | {landUseCategory} | {landUse} </p>
                    </div>
                </div>

                {/* <div className="flex flex-wrap items-centerx gap-3 pb-4">
                    {isEditing ? (
                        <>
                            <button
                                onClick={onCancel}
                                disabled={isSaving}
                                className="edit-btn"
                            >
                                Discard changes
                            </button>
                            <button
                                onClick={onSave}
                                disabled={isSaving}
                                className="save-btn"
                            >
                                {isSaving ? "Saving..." : "Save parcel updates"}
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={onEdit}
                            className="edit-btn"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="#FFF" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                            Edit parcel
                        </button>
                    )}

                    {saveMessage && (
                        <span className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-medium text-emerald-700">
                            {saveMessage}
                        </span>
                    )}
                </div> */}
            </div>

            {saveError && (
                <div className="mt-4 rounded-lg border border-destructive/50 bg-destructive/10 p-3 text-sm text-destructive">
                    {saveError}
                </div>
            )}
        </header>
    );
}